import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { User, UserService } from '@fry/lib/users';
import { FormData } from '@fry/lib/forms';

import { UserEditRolesForm } from './user-edit-roles.form';
import { NotifyService } from '@fry/lib/utils';
import { CanComponentDeactivate } from '@fry/components/common/form';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-user-edit-roles',
    templateUrl: './user-edit-roles.component.html',
    providers: [
        UserEditRolesForm
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserEditRolesComponent implements OnInit, CanComponentDeactivate {

  public user: User;
  public formData$: Observable<FormData>;

  constructor(
    private userService: UserService,
    private rolesForm: UserEditRolesForm,
    private notify: NotifyService
  ) { }

  ngOnInit() {
    this.user = this.userService.user;
    this.formData$ = this.rolesForm.init(this.user);
  }

  onSubmit() {
    this.rolesForm.submit(this.user).subscribe(
      (user) => {
        this.userService.setUser(user);
        this.user = this.userService.user;
        this.notify.success($localize `Profile successfully saved`);
      },
      error => {
        this.notify.error(error);
      }
    );
  }

  canSafelyDeactivate() {
    return this.rolesForm.pristine;
  }
}
